<button
  class="btn font-weight-bold"
  [ngClass]="getColorClass()"
  (click)="onClick()"
  [disabled]="disabled"
  [type]="type"
>
  {{ label }}
</button>
